<template>
  <div>
    <vs-prompt
      :title="titleText"
      @accept="acceptAddNewTaskPrompt"
      :active.sync="addNewTaskPrompt"
      :accept-text="titleText"
      :is-valid="validForm"
      class="venue-task-popup"
    >
      <vs-row v-if="task">
        <vs-col vs-w="8">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Role</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-select class="selectVenue" style="width: 100%" v-model="task.role">
                <div :key="item.id" v-for="item in selectableRoles">
                  <vs-select-item :value="item.id" :text="item.title" />
                </div>
              </vs-select>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Task</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input class="inputx w-full" placeholder="Example: empty trash" v-model="task.title" />
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Note</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-textarea class="inputx w-full" placeholder="Note" v-model="task.note" />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Place</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full" style="z-index: 9999">
              <gmap-autocomplete
                class="addressInput vs-inputx vs-input--input normal"
                placeholder="Type location or address"
                @place_changed="updateAddress"
                :value="task.address"
                :select-first-on-enter="true"
              >
                <template v-slot:input="slotProps">
                  <v-text-field
                    outlined
                    prepend-inner-icon="place"
                    placeholder="Type location or address"
                    ref="input"
                    v-on:listeners="slotProps.listeners"
                    v-on:attrs="slotProps.attrs"
                  >
                  </v-text-field>
                </template>
              </gmap-autocomplete>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Venues</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full" style="z-index: 9999">
              <VenueSelector v-model="task.venueIds" :multiple="true" />
            </div>
          </div>

          <vs-divider color="rgb(220, 220, 220)" />

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Date/Time</span>
            </div>
            <div class="vx-col sm:w-2/5 w-full" style="z-index: 1001">
              <v-date-picker
                v-model="task.startDate"
                mode="dateTime"
                is24hr
                :masks="{ L: 'DD-MM-YYYY' }"
                :attributes="[{ highlight: { fillMode: 'light' }, dates: new Date() }]"
              >
                <template v-slot="{ inputValue, inputEvents }">
                  <vs-input :value="inputValue" v-on="inputEvents" />
                </template>
              </v-date-picker>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Repeat</span>
            </div>
            <div class="vx-col sm:w-2/5 w-full">
              <vs-checkbox v-model="task.isRecurring">Repeat task</vs-checkbox>
            </div>
          </div>

          <transition name="fade">
            <div class="vx-row mb-6" v-if="task.isRecurring">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Days</span>
              </div>
              <div class="vx-col sm:w-4/5 w-full" style="display: flex">
                <vs-checkbox v-for="(day, index) in recurringDays" :key="index" v-model="selectedRecurringDays" :vs-value="day.id">{{
                  day.name
                }}</vs-checkbox>
              </div>
            </div>
          </transition>

          <transition name="fade">
            <div class="vx-row mb-6" v-if="task.isRecurring">
              <div class="vx-col sm:w-1/5 w-full"></div>
              <div class="vx-col sm:w-4/5 w-full">
                <span style="color: #ccc">Repeats {{ recurringText }}</span>
              </div>
            </div>
          </transition>

          <transition name="fade">
            <div class="vx-row mb-6" v-if="task.isRecurring">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Stop repeat</span>
              </div>
              <div class="vx-col sm:w-2/5 w-full" style="z-index: 999">
                <v-date-picker v-model="task.endDate" :masks="{ L: 'DD-MM-YYYY' }">
                  <template v-slot="{ inputValue, inputEvents }">
                    <vs-input :value="inputValue" v-on="inputEvents" />
                  </template>
                </v-date-picker>
                <span style="color: #ccc">The last day this task may occur</span>
              </div>
            </div>
          </transition>

          <vs-divider color="rgb(220, 220, 220)" />

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">Notify</div>
            <div class="vx-col sm:w-2/5 w-full">
              <vs-checkbox v-model="task.notifyMe">Notify in LIFE app</vs-checkbox>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Flagged</span>
            </div>
            <div class="vx-col sm:w-2/5 w-full pl-5">
              <feather-icon
                v-if="!task.flagged"
                icon="FlagIcon"
                svgClasses="w-6 h-6 hover:text-primary cursor-pointer"
                @click.stop="task.flagged = true"
              />
              <feather-icon
                v-if="task.flagged"
                icon="FlagIcon"
                svgClasses="w-6 h-6 text-warning cursor-pointer"
                @click.stop="task.flagged = false"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Responsible</span>
            </div>
            <div class="vx-col sm:w-3/5 w-full">
              <div v-if="editingResponsible || !task.responsibleUserId" class="flex items-center">
                <IdmUserSearcher @onHit="onResponsibleSelected" placeholder="Please enter responsible name or email" class="w-full" />
                <vs-button v-if="task.responsibleUserId" @click="editingResponsible = false" type="flat" class="px-3 py-2">
                  <feather-icon icon="XIcon" svgClasses="w-5 h-5" />
                </vs-button>
              </div>

              <div v-else class="flex items-center">
                <vs-chip color="green">{{ task.responsibleName }}</vs-chip>
                <vs-button @click="editingResponsible = true" type="flat" class="ml-1 px-3 py-2">
                  <feather-icon icon="EditIcon" svgClasses="w-5 h-5" />
                </vs-button>
                <vs-button @click="onRemoveResponsible" type="flat" class="px-3 py-2">
                  <feather-icon icon="XIcon" svgClasses="w-5 h-5" />
                </vs-button>
              </div>
            </div>
          </div>

          <div class="buttons-footer-left">
            <vs-button v-if="!isNew" color="danger" @click.native="confirmDelete" :type="!task.isRecurring ? 'border' : 'filled'" class=""
              >Delete{{ task.isRecurring ? "" : "" }}</vs-button
            >
          </div>
        </vs-col>
        <vs-col vs-w="4" class="px-5" vs-justify="center">
          <vs-row vs-justify="center">
            <h3>Image</h3>
            <TaskImages :venueTaskId="task.id" :imageUrls="task.imageUrls" style="width: 100%" />
          </vs-row>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>

<script>
import _ from "lodash";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";

import { mapGetters } from "vuex";
import { RRule, RRuleSet, rrulestr } from "rrule";
import IdmUserSearcher from "@/components/IdmUserSearcher.vue";

import VenueSelector from "@/components/VenueSelector.vue";
import { ClientSideRowModelSteps } from "ag-grid-community";

const TaskImages = () => import("./TaskImages.vue");

export default {
  components: {
    TaskImages,
    flatPickr,
    VenueSelector,
    IdmUserSearcher
  },
  props: [],
  data() {
    return {
      addNewTaskPrompt: false,
      isNew: false,
      task: null,

      editingResponsible: false,

      rruleConfig: {
        freq: RRule.WEEKLY
      },
      exclusionDays: [],
      selectedRecurringDays: [],
      recurringDays: [
        { id: 0, name: "Mon" },
        { id: 1, name: "Tue" },
        { id: 2, name: "Wed" },
        { id: 3, name: "Thu" },
        { id: 4, name: "Fri" },
        { id: 5, name: "Sat" },
        { id: 6, name: "Sun" }
      ]
    };
  },
  // Watch the start date
  watch: {
    "task.startDate": function (newStartDate) {
      console.log("CHANGED START DATAE", newStartDate);
      if (!this.task.endDate || !this.task.isRecurring || !moment(this.task.endDate).isAfter(moment(newStartDate))) {
        this.task.endDate = newStartDate;
        console.log("End date is now", this.task.endDate);
      }
    }
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      userId: "users/userId",
      venues: "venues/venues",
      selectableRoles: "venueTasks/roles"
    }),
    validForm() {
      return (
        this.task &&
        this.task.title !== "" &&
        this.task.startDate &&
        // this.task_role !== "" && // "" just means "Other Tasks"
        (!this.task.isRecurring || (this.task.endDate && moment(this.task.endDate).isAfter(moment(this.task.startDate))))
      );
    },
    titleText() {
      return (this.isNew ? "Add " : "Update ") + "task";
    },

    recurringText() {
      const rrule = new RRule({
        ...this.rruleConfig,
        byweekday: this.selectedRecurringDays,
        dtstart: moment(this.task.startDate).toDate(),
        until: moment(this.task.endDate).toDate()
      });
      return rrule.toText();
    }
  },
  methods: {
    updateAddress: function (payload) {
      this.task.address = payload.formatted_address;
      const lat = payload.geometry.location.lat();
      const lng = payload.geometry.location.lng();

      this.task.latitude = lat;
      this.task.longitude = lng;
    },

    getAddressComponent: function (address, component) {
      var result = address.address_components.filter(cmp => {
        if (cmp.types.includes(component)) {
          return true;
        }

        return false;
      });

      if (result.length == 0) {
        return "";
      }

      return result[0].long_name;
    },

    onResponsibleSelected(selectedItem) {
      var userInfo = {
        id: selectedItem.userId,
        displayName: selectedItem.firstName + " " + selectedItem.lastName,
        email: selectedItem.email
      };

      this.task.responsibleUserId = userInfo.id;
      this.task.responsibleName = userInfo.displayName;
    },
    onRemoveResponsible() {
      this.task.responsibleUserId = null;
      this.task.responsibleName = null;
    },

    confirmDelete() {
      this.addNewTaskPrompt = false;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Delete task?",
        accept: this.deleteEvent
      });
    },
    async deleteEvent() {
      console.log("Deleting task");
      this.$vs.loading();
      await this.$store.dispatch("venueTasks/deleteVenueTask", this.task.id);

      this.$vs.loading.close();
      this.$vs.notify({
        color: "danger",
        title: "Deleted task",
        text: "The task was deleted"
      });

      console.log("EMITTING", this, this.$emit);
      this.$root.$emit("venueTaskChanged");
    },
    show(date) {
      // if date is moment date, then convert to js date
      if (date && date._isAMomentObject) {
        date = date.toDate();
      }
      this.isNew = true;

      this.task = {
        id: (Math.random() + 1).toString(36).substring(2), // TODO change?
        title: "",
        note: "",
        startDate: null,
        endDate: null,
        userId: this.userId, // TODO Remove?
        flagged: false,
        isRecurring: false,
        rRule: null,
        role: "",
        address: "",
        latitude: 0,
        longitude: 0,
        imageUrls: [],
        responsibleName: "",
        responsibleUserId: null,
        venueIds: [this.activeVenue.venueId],
        notifyMe: false
      };

      this.addNewTaskPrompt = true;

      this.exclusionDays = [];
      this.selectedRecurringDays = [];

      if (date) {
        var now = new Date();
        date.setHours(now.getHours());
        date.setMinutes(now.getMinutes());
        date.setSeconds(0);

        this.task.startDate = date;
        this.task.endDate = date;
      } else {
        this.task.startDate = null;
        this.task.endDate = null;
      }
      console.log("DATE IS", this.task.startDate);
    },
    showWith(data) {
      console.log("Showing with task", data);
      this.isNew = false;
      this.task = {
        id: data.venueTaskId,
        title: data.title,
        note: data.note,
        startDate: data.startDate,
        endDate: data.endDate,
        userId: data.userId, // Consider
        flagged: data.flagged,
        isRecurring: data.isRecurring,
        rRule: data.rRule,
        role: data.role,
        address: data.address,
        latitude: data.latitude,
        longitude: data.longitude,
        imageUrls: data.imageUrls,
        responsibleName: data.responsibleName,
        responsibleUserId: data.responsibleUserId,
        venueIds: data.venueIds,
        notifyMe: data.notifyMe
      };

      if (this.task.isRecurring) {
        const tRuleSet = rrulestr(this.task.rRule, { forceset: true });
        const tRule = tRuleSet.rrules()[0]; // important: assumes only one rule per set
        this.selectedRecurringDays = tRule.options.byweekday;
        this.exclusionDays = tRuleSet.exdates();
      }

      this.addNewTaskPrompt = true;
    },
    async acceptAddNewTaskPrompt() {
      if (this.task.isRecurring) {
        const rrule = new RRule({
          ...this.rruleConfig,
          byweekday: this.selectedRecurringDays,
          // dtstart: moment.utc(this.task_startDate, this.momentFormat).toDate(),
          until: moment(this.task.endDate).add(23, "hours").add(59, "minutes").toDate() // End of the day YYYY-MM-DD 23:59
        });

        const rruleSet = new RRuleSet();

        // Add a rrule to rruleSet
        rruleSet.rrule(rrule);
        if (this.exclusionDays) this.exclusionDays.forEach(e => rruleSet.exdate(e));

        this.task.rRule = rruleSet.toString();
      }

      this.$vs.loading();
      try {
        if (!this.isNew) {
          console.log("Updating task", this.task);
          await this.$store.dispatch("venueTasks/updateVenueTask", this.task);
        } else {
          console.log("Adding task", this.task);
          await this.$store.dispatch("venueTasks/addVenueTask", this.task);
        }
        this.$root.$emit("venueTaskChanged");

        this.$vs.notify({
          color: "success",
          title: "Task " + (!this.isNew ? "updated" : "added"),
          text: "Your task was " + (!this.isNew ? "updated" : "added")
        });
      } catch (err) {
        console.error("Venue task api call failed: " + err);
      } finally {
        this.$vs.loading.close();
      }
    }
  }
};
</script>

<style lang="scss" >
.pac-container {
  // Google autocomplete
  z-index: 1000000;
}

.venue-task-popup {
  .addressInput {
    width: 100%;
  }

  .con-select-venue {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .con-select .vs-select {
    width: 100%;
  }
  @media (max-width: 550px) {
    .con-select {
      flex-direction: column;
    }
    .con-select .vs-select {
      width: 100%;
    }
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .con-chips--remove-all {
    display: none;
  }

  .buttons-footer-left {
    position: absolute;
    bottom: 14px;
    z-index: 100;
    animation: fadeIn ease 500ms forwards;
    animation-delay: 500ms;
    opacity: 0;
  }

  &.con-vs-dialog .vs-dialog {
    max-width: 1000px !important;
    position: relative;
  }
}
</style>
